@if (loadingState === 'success') {
  <router-outlet></router-outlet>
}

@if (loadingState === 'loading') {
  <div class="load-container h-100">
    <svg class="spinner" viewBox="0 0 50 50">
      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
    </svg>
  </div>
}

@if (loadingState === 'error') {
  <auex-bootstrap-error></auex-bootstrap-error>
}
